module.exports = __webpack_public_path__ + "img/Mali.9b721a8d.gif";